import {useState, useEffect, use} from "react";
import { apiRequest } from "../../network/apiClient";
import { API_ENDPOINTS } from "../../api/apiEndpoints";

export const useHunterFarmerList = () => {
    const [hunterList, setHunterList] = useState([])
    const [farmerList, setFarmerList] = useState([])

    useEffect(() =>{
        const fetchData = async() => {
            try{
                    const resultHunter = await apiRequest(`${import.meta.env.VITE_BASE_URL}/${API_ENDPOINTS.AUTH.HUNTER_LIST}`, 'GET');
                    if(resultHunter) {
                    setHunterList(resultHunter);
                }
                const resultFarmer = await apiRequest(`${import.meta.env.VITE_BASE_URL}/${API_ENDPOINTS.AUTH.FARMER_LIST}`, 'GET');
                if(resultFarmer) {
                    setFarmerList(resultFarmer);
                }
            }catch(error){
                console.error("Error fetching data:", error)
            }
        };
        fetchData();
    }, []);

    return {hunterListAPI: hunterList, farmerListAPI: farmerList};
}
